import React from "react";
import "./Auth.scss";

const AuthLayout = ({ children }: any) => {
  return (
    <div className="authContainer">
      <div className="auth_box">
        <figure className="auth_logo">
          <img src="/static/images/butterfly_logo2.svg" alt="logo" />
        </figure>
      
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
